
export const firebaseConfig = {
  /*apiKey: "AIzaSyA9tJ1p8iDcYy6tLoOisnr4zXFbS8aHEag",
  authDomain: "restaurant-1440e.firebaseapp.com",
  databaseURL: "https://restaurant-1440e.firebaseio.com",
  storageBucket: "restaurant-1440e.appspot.com",
  messagingSenderId: "314198464457"*/

  
  apiKey: "AIzaSyCyu05pTyNOr9ZJBRm27bg_wg5WFOUfd2k",
  authDomain: "push-notifications-e903d.firebaseapp.com",
  databaseURL: "https://push-notifications-e903d.firebaseio.com",
  projectId: "push-notifications-e903d",
  storageBucket: "push-notifications-e903d.appspot.com",
  messagingSenderId: "442257306934"

  

  /*
  apiKey: "AIzaSyDOTjtB3uxH0udgaTZKZOs9zTuK-nJnMos",
  authDomain: "foonyew2backend.firebaseapp.com",
  databaseURL: "https://foonyew2backend.firebaseio.com",
  databaseURL: "https://push-notifications-e903d.firebaseio.com",
  projectId: "foonyew2backend",
  storageBucket: "foonyew2backend.appspot.com",
  messagingSenderId: "1026380026619"
  */
};

export const cloudinarUpload = {
  cloudName: 'ocomedia',
  uploadPreset: 'ui0cyga0'
};





// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/firebase.config.ts